"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gorevlendirmeListesiSchema = exports.isyeriZorunluGorevlendirmelerSchema = exports.isyeriZorunluGorevlendirmeSatiriSchema = exports.gorevlendirmeListeSatiriSchema = exports.gorevlendirmeKaldirSchema = exports.gorevlendirmeOlusturSchema = exports.kisiUygunlukPaneliSchema = exports.gorevlendirmeSchema = exports.uygunlukSatiriSchema = exports.EKSIK_SAYILAN_DURUMLAR = exports.EKSIK_KAYIT_YOK_ETIKETI = exports.UYGUNLUK_DURUM_ETIKETI = exports.uygunlukDurumuSchema = exports.UYGUNLUK_DURUMLARI = exports.gorevlendirmeKuraliSchema = exports.belirlenmeYoluSchema = exports.BELIRLENME_YOLLARI = exports.GOREVLENDIRME_KURUL_UYESI_REF = exports.GOREVLENDIRME_YAZMA_SAPKALARI = exports.GOREVLENDIRME_KUCUK_ISYERI_REF = exports.GOREVLENDIRME_TRAFIK_REF = exports.GOREVLENDIRME_CEVRE_REF = exports.GOREVLENDIRME_KOORDINATOR_REF = exports.GOREVLENDIRME_KORUMA_REF = exports.GOREVLENDIRME_KURTARMA_REF = exports.GOREVLENDIRME_SONDURME_REF = exports.GOREVLENDIRME_ILKYARDIMCI_REF = exports.GOREVLENDIRME_TEMSILCI_REF = exports.zorunluSayiSchema = exports.zorunluSayiBasamakSchema = exports.gorevlendirmeNesneEkseniSchema = exports.GOREVLENDIRME_NESNE_EKSENLERI = void 0;
exports.readZorunluSayi = readZorunluSayi;
exports.gerekenGorevlendirmeSayisi = gerekenGorevlendirmeSayisi;
exports.zorunluSayiGevsetmeIhlalleri = zorunluSayiGevsetmeIhlalleri;
exports.readGorevlendirmeKurali = readGorevlendirmeKurali;
exports.gorevlendirmeNesneIhlalleri = gorevlendirmeNesneIhlalleri;
exports.uygunlukSatirDurumu = uygunlukSatirDurumu;
exports.gorevlendirmeEksikMi = gorevlendirmeEksikMi;
const zod_1 = require("zod");
const egitim_1 = require("./egitim");
const kurul_1 = require("./kurul");
const saglik_1 = require("./saglik");
/**
 * GÖREVLENDİRME — kural katmanı (Tur 4½; Kapsam §25, ERD §3f).
 *
 * **BÖLÜMÜN TEK CÜMLESİ: GÖREVLENDİRME BİR ŞAPKA DEĞİLDİR.** Şapka
 * (`role_assignment`) *"sistemde ne yapabilirsin"* der; görevlendirme
 * *"sahada hangi görevi taşıyorsun"* der. Bu dosyadaki hiçbir yüklem bir
 * guard'a, bir `@RequireRole` listesine ya da bir bahçe çözümüne girmez —
 * *nitelik ≠ yetki* (§25/1).
 *
 * BURADA YAŞAYAN KURALLAR (hepsinin TEK okuyucusu var):
 *   readGorevlendirmeKurali      — G3/G4: tür kaleminin kural ekseni
 *   gorevlendirmeNesneIhlalleri  — G3: nesne ekseni kapısı (422)
 *   uygunlukSatirDurumu          — G5/G6: DÖRT durum, TEK yüklem
 *   gorevlendirmeEksikMi         — G5: "eksik" damgası TÜRETİLİR
 *
 * ⚠️ **DAMGA SAKLANMAZ.** `employment_designation` bir uygunluk kolonu
 * taşımaz: saklanan bir boolean, belgenin girildiği gün **yalan söylemeye
 * başlardı** (`equipment.son_kontrol` türetmesinin ve `olayKapaliMi`nin aynı
 * ailesi).
 */
// ── G3 — NESNE EKSENİ ───────────────────────────────────────────────────────
/**
 * Tür kaleminin nesne ekseni. **İKİ DEĞER:**
 *   `yok`          — işyeri düzeyi (ilkyardımcı, yangın ekibi…). Ayrı bir
 *                    işyeri kolonu YOKTUR: istihdam zaten bir işyerine
 *                    bağlıdır (madde 80) ve ikinci kez yazmak çelişebilirdi.
 *   `ekipman_tipi` — operatörlükler. **Belge TİPE göre verilir** ve saha
 *                    gerçeği budur: forklift belgesi olan kişi otomatik
 *                    olarak vinç operatörü değildir.
 *
 * ⚠️ **EKİPMAN BAZLI ÜÇÜNCÜ DEĞER v1'DE YOK** (kule vinç vakası: *"bu kişi
 * yalnız 3 no'lu kule vinci kullanır"*) — ERD §12/43, ürün sahibinde.
 */
exports.GOREVLENDIRME_NESNE_EKSENLERI = ['yok', 'ekipman_tipi'];
exports.gorevlendirmeNesneEkseniSchema = zod_1.z.enum(exports.GOREVLENDIRME_NESNE_EKSENLERI);
// ── G4 — ŞART MATRİSİ, TÜR KALEMİNİN KURALIDIR ──────────────────────────────
/**
 * Görevlendirme türü kaleminin kural seti (`lookup_item.kurallar`).
 *
 * ⚠️ **YÖN KARARI (§25/4).** PTW'de kural **yetkinlik kaleminin** üstündedir
 * (`izinde_aranir` — *"nerede aranırım"*); burada **türün** üstündedir
 * (*"ben şunları isterim"*). Sebep mekanik: **§19/11 kural ekseni sonradan
 * eklenemez** der ve yetkinlik kalemlerine üçüncü bir eksen
 * (`gorevlendirmede_aranir`) eklemek tam olarak o yasağın ihlali olurdu.
 * **Yeni liste kendi eksenini doğarken tanımlar** — o serbesttir.
 *
 * ⚠️ **`saglik_kanaati_gerekli` AYRI EKSENDİR, BİR YETKİNLİK KALEMİ DEĞİL.**
 * *"Ağır ve tehlikeli işler raporu"* / *"yüksekte çalışma raporu"* gibi
 * kalemler **AÇILMAZ** (ürün sahibi kararı — §25/4): işe giriş / periyodik
 * muayenenin **kanaat raporundaki ibare yeterlidir** ve o zaten sistemdedir.
 * Ayrı kalem, aynı olguyu ikinci kez kaydetmek ve §2.3'ün kilitli sağlık
 * mimarisini **ikinci bir kapıyla** delmek olurdu.
 */
// ── 5½ / B2 — ZORUNLU SAYI KURALI (Kapsam §25/12) ──────────────────────────
/**
 * **BİR İŞYERİ BU GÖREVLENDİRMEDEN EN AZ KAÇ KİŞİ TAŞIMALI?** Tür kaleminin
 * kuralındaki DÖRDÜNCÜ anahtar (`zorunlu_sayi`). İki biçim, tek okuyucu:
 *
 *   basamak — çalışan aralığı → sayı (temsilci: 2-50→1 · 51-100→2 …)
 *   oran    — tehlike sınıfı eksenli *"N çalışana 1"* (gereken = ⌈çalışan/bölen⌉)
 *
 * ⚠️ **SONUÇ KOLONU YOK — her okumada türetilir** (G5 ailesi). ⚠️ **Oran
 * biçiminde `bolen` NULL olabilir:** kütüphane ilkyardımcı ve acil durum
 * ekiplerini **değersiz** dağıtır (sayılar uydurulmaz — madde 175); bölen
 * yoksa okuyucu **susar** (`gereken = null`), *"eksik"* demez —
 * `isyeri_oran` deseni.
 *
 * ⚠️ **`isyeri_oran` (§19/11-8) İLE AYNI ŞEY DEĞİLDİR:** o yetkinlik
 * ekseninde *"sertifikası olan kaç kişi"* der; bu görevlendirme ekseninde
 * *"görevlendirilmiş kaç kişi"* der. İki ölçü, tek soru değil.
 */
exports.zorunluSayiBasamakSchema = zod_1.z.object({
    alt: zod_1.z.number().int().min(0),
    ust: zod_1.z.number().int().min(0).nullable(),
    sayi: zod_1.z.number().int().min(0),
});
exports.zorunluSayiSchema = zod_1.z.discriminatedUnion('bicim', [
    zod_1.z.object({ bicim: zod_1.z.literal('basamak'), basamaklar: zod_1.z.array(exports.zorunluSayiBasamakSchema).min(1) }),
    zod_1.z.object({
        bicim: zod_1.z.literal('oran'),
        bolen: zod_1.z
            .object({
            az: zod_1.z.number().int().positive(),
            tehlikeli: zod_1.z.number().int().positive(),
            cok: zod_1.z.number().int().positive(),
        })
            .nullable(),
    }),
]);
/** Tanınmayan/bozuk değer `null` — kural yokmuş gibi (readUyariEsigiGun deseni). */
function readZorunluSayi(kurallar) {
    if (kurallar === null || typeof kurallar !== 'object' || Array.isArray(kurallar))
        return null;
    const parsed = exports.zorunluSayiSchema.safeParse(kurallar.zorunlu_sayi);
    return parsed.success ? parsed.data : null;
}
/**
 * Gereken sayı — **TEK OKUYUCU.** `null` = kural sayı üretmiyor (bölen boş)
 * → sistem susar. Basamakta aralık dışı (ilk basamağın altı) sıfırdır: iki
 * çalışanlı işyerinde temsilci istenmez (Yönetmelik md. 20 alt sınırı 2'dir
 * ve o alt sınır TABLODADIR, kodda değil).
 */
function gerekenGorevlendirmeSayisi(kural, calisanSayisi, tehlikeSinifi) {
    if (kural === null)
        return null;
    if (kural.bicim === 'oran') {
        if (kural.bolen === null)
            return null;
        return Math.ceil(calisanSayisi / kural.bolen[(0, egitim_1.tehlikeSinifiAnahtari)(tehlikeSinifi)]);
    }
    const basamak = kural.basamaklar.find((b) => calisanSayisi >= b.alt && (b.ust === null || calisanSayisi <= b.ust));
    return basamak ? basamak.sayi : 0;
}
/**
 * **SAYILAR EN AZDIR — müşteri artırabilir, AZALTAMAZ** (§19/7 sert
 * listesinin beşinci kalemi; ürün sahibi 04.09.2026). Kütüphane nüshasında
 * yeni kural, kütüphane kuralının altına **hiçbir çalışan sayısında**
 * inemez. Ölçüm örnek noktalarda yapılır: iki tablonun tüm basamak
 * sınırları (alt · ust · ust+1) — iki parçalı-sabit fonksiyonun farkı ancak
 * sınırlarda değişir. Biçim değiştirmek ve anahtarı silmek de gevşetmedir.
 * Kütüphane değersizse (oran, bölen yok) taban yoktur.
 */
function zorunluSayiGevsetmeIhlalleri(kutuphane, yeni) {
    if (kutuphane === null)
        return [];
    if (kutuphane.bicim === 'oran' && kutuphane.bolen === null)
        return [];
    if (yeni === null) {
        return [
            'Zorunlu sayı kuralı kaldırılamaz: kütüphane değeri en az sayıdır, müşteri artırabilir, azaltamaz.',
        ];
    }
    if (yeni.bicim !== kutuphane.bicim) {
        return [
            'Zorunlu sayının biçimi değiştirilemez: kütüphane değeri en az sayıdır, müşteri artırabilir, azaltamaz.',
        ];
    }
    if (kutuphane.bicim === 'oran' && yeni.bicim === 'oran') {
        if (yeni.bolen === null) {
            return ['Zorunlu sayı boş bırakılamaz: kütüphane değeri en az sayıdır.'];
        }
        const ihlal = [];
        for (const anahtar of ['az', 'tehlikeli', 'cok']) {
            if (yeni.bolen[anahtar] > kutuphane.bolen[anahtar]) {
                ihlal.push(`Zorunlu sayı gevşetilemez (${anahtar}: ${yeni.bolen[anahtar]} çalışana 1 > kütüphane ${kutuphane.bolen[anahtar]} çalışana 1).`);
            }
        }
        return ihlal;
    }
    if (kutuphane.bicim === 'basamak' && yeni.bicim === 'basamak') {
        const noktalar = new Set([0, 1]);
        for (const b of [...kutuphane.basamaklar, ...yeni.basamaklar]) {
            noktalar.add(b.alt);
            if (b.ust !== null) {
                noktalar.add(b.ust);
                noktalar.add(b.ust + 1);
            }
        }
        for (const n of [...noktalar].sort((a, b) => a - b)) {
            // Tehlike sınıfı basamakta okunmaz; imza gereği verilir.
            const taban = gerekenGorevlendirmeSayisi(kutuphane, n, 'low_risk') ?? 0;
            const deger = gerekenGorevlendirmeSayisi(yeni, n, 'low_risk') ?? 0;
            if (deger < taban) {
                return [
                    `Zorunlu sayı gevşetilemez: ${n} çalışanda kütüphane ${taban} ister, yeni kural ${deger} veriyor. Müşteri artırabilir, azaltamaz.`,
                ];
            }
        }
    }
    return [];
}
/**
 * 5½ / B1 — ÇALIŞAN TEMSİLCİSİ türünün kütüphane çapası. `employee_rep` ek
 * fonksiyonu **bu ref'in nüshasına verilen yürürlükteki görevlendirmeden
 * türetilir** (§25/13); baş temsilci / belirlenme yolu alanları yalnız bu
 * türde yazılır. Müşteri kalemi bu türü **taklit edemez** — türetme ref'e
 * bakar, ada değil.
 */
exports.GOREVLENDIRME_TEMSILCI_REF = 'cb000000-0000-4000-8000-000000000017';
/**
 * **TUR 8 / A1 — SAYILAN GÖREVLENDİRME TÜRLERİ.** *"Bu işyerinde kaç
 * ilkyardımcı var"* sorusunun **TEK** cevabı görevlendirme kaydıdır; yasal
 * uygunluk takvimi bu ref'ler üzerinden sayar ve **ikinci bir sayaç
 * AÇMAZ** (`isyeriIlkYardimciOrani` tam olarak o ikinci sayaçtı ve söküldü).
 * ⚠️ Ref'ler burada durur çünkü **iki kütüphane de** onları okur: sözlük
 * nüshası (kalemin kendisi) ve yükümlülük haritası (hangi kalem hangi türü
 * sayar). Ada göre eşleşme YAZILMAZ — müşteri kalemi adı taklit edebilir.
 */
exports.GOREVLENDIRME_ILKYARDIMCI_REF = 'cb000000-0000-4000-8000-000000000001';
exports.GOREVLENDIRME_SONDURME_REF = 'cb000000-0000-4000-8000-000000000002';
exports.GOREVLENDIRME_KURTARMA_REF = 'cb000000-0000-4000-8000-000000000003';
exports.GOREVLENDIRME_KORUMA_REF = 'cb000000-0000-4000-8000-000000000004';
/**
 * ACİL DURUM (Kapsam §29/E2 — 06.09.2026): üç ek ekip kalemi. Zorunlu sayı
 * kuralları BÖLENSİZ dağıtılır (madde 175'in kalan yarısı — tur 8 / A5);
 * acil durum ekranı bu üçünde *"tanımsız"* gösterir, sıfır ya da "tam" değil.
 */
exports.GOREVLENDIRME_KOORDINATOR_REF = 'cb000000-0000-4000-8000-000000000005';
exports.GOREVLENDIRME_CEVRE_REF = 'cb000000-0000-4000-8000-000000000006';
exports.GOREVLENDIRME_TRAFIK_REF = 'cb000000-0000-4000-8000-000000000007';
/** A6 — 18. kalem (ürün sahibi onayı 05.09.2026); kapsam 1-9 çalışan. */
exports.GOREVLENDIRME_KUCUK_ISYERI_REF = 'cb000000-0000-4000-8000-000000000018';
/**
 * İSG KURULU (Kapsam §28/C2) — ON DOKUZUNCU kalem: *"Kurul üyesi"*. Üyelik
 * bu türün yürürlükteki görevlendirmesidir; alt tip `kurul_uye_tipi`
 * YALNIZ bu türde zorunlu. REF'ten tanınır, adından değil.
 */
/**
 * Görevlendirme YAZABİLEN şapkalar — yetkinlik yazma ucunun birebir aynısı
 * (§25 uç→şapka tablosu; `write-role-inventory` kilitler). Kişi kartı bölümü,
 * kurul sayfasının üye satırı (G3.1) ve `POST persons/:id/designations` AYNI
 * listeyi okur — ekran şapka listesi türetmez (§2.40).
 */
exports.GOREVLENDIRME_YAZMA_SAPKALARI = [
    'holding_admin',
    'company_admin',
    'isg_specialist',
];
exports.GOREVLENDIRME_KURUL_UYESI_REF = 'cb000000-0000-4000-8000-000000000019';
exports.BELIRLENME_YOLLARI = ['secim', 'atama'];
exports.belirlenmeYoluSchema = zod_1.z.enum(exports.BELIRLENME_YOLLARI);
exports.gorevlendirmeKuraliSchema = zod_1.z.object({
    nesneEkseni: exports.gorevlendirmeNesneEkseniSchema,
    /**
     * `yetkinlik_tipi` **veya** `egitim_turu` NÜSHA kimlikleri.
     *
     * ⚠️ **KÜTÜPHANEDE KÜTÜPHANE REF'İ DURUR; DAĞITIMDA NÜSHA KİMLİĞİNE
     * ÇÖZÜLÜR** (fail-loud — `distributeFormLibrary`nin tür bağı deseni).
     * Çözülmeseydi müşteri **kendi kalemini** matrise ekleyemezdi ve G4'ün
     * *"müşteri ekler"* yarısı ölü kalırdı.
     */
    gerekenYetkinlikler: zod_1.z.array(zod_1.z.uuid()),
    saglikKanaatiGerekli: zod_1.z.boolean(),
    /** 5½ / B2 — bildirilmemiş = kural yok (sistem susar). */
    zorunluSayi: exports.zorunluSayiSchema.nullable(),
});
/** Kuralsız/bozuk kalem için güvenli taban — bildirilmemiş eksen `yok`. */
const GOREVLENDIRME_KURAL_TABANI = {
    nesneEkseni: 'yok',
    gerekenYetkinlikler: [],
    saglikKanaatiGerekli: false,
    zorunluSayi: null,
};
/**
 * Sözlük kaleminin opak `kurallar` jsonb'sinden görevlendirme eksenlerini
 * okur. **Tanınmayan/bozuk değer TABANA düşer** — `readUyariEsigiGun`
 * deseni: bir sözlük satırının bozukluğu ekranı çökertmez, kural yokmuş gibi
 * davranır ve şart üretmez.
 */
function readGorevlendirmeKurali(kurallar) {
    if (kurallar === null || typeof kurallar !== 'object' || Array.isArray(kurallar)) {
        return GOREVLENDIRME_KURAL_TABANI;
    }
    const ham = kurallar;
    const eksen = exports.gorevlendirmeNesneEkseniSchema.safeParse(ham.nesne_ekseni);
    const yetkinlikler = zod_1.z.array(zod_1.z.uuid()).safeParse(ham.gereken_yetkinlikler);
    return {
        nesneEkseni: eksen.success ? eksen.data : 'yok',
        gerekenYetkinlikler: yetkinlikler.success ? yetkinlikler.data : [],
        saglikKanaatiGerekli: ham.saglik_kanaati_gerekli === true,
        zorunluSayi: readZorunluSayi(kurallar),
    };
}
/**
 * G3 KAPISI — **kural SERVİSTEDİR, DB CHECK DEĞİL** ve bu bir zorunluluktur:
 * ekseni tür kaleminin SATIRI söyler, **DB CHECK başka tablonun satırını
 * okuyamaz** (§2.6'nın *"Diğer" gerekçe* deseninin aynısı).
 *
 * İhlal **422**'dir (kural ihlali), 403 değil (yetki sorunu değil) ve 409
 * değil (kayıt-durumu çatışması değil). Mesajlar **D2 dilindedir** —
 * kullanıcı `nesne_ekseni` gibi bir iç adı değil, **ne yapacağını** duyar.
 */
function gorevlendirmeNesneIhlalleri(kural, ekipmanTipiId) {
    if (kural.nesneEkseni === 'ekipman_tipi' && ekipmanTipiId === null) {
        return ['Bu görevlendirme bir ekipman tipine bağlanır — ekipman tipi seçin.'];
    }
    if (kural.nesneEkseni === 'yok' && ekipmanTipiId !== null) {
        return ['Bu görevlendirme işyeri düzeyindedir — ekipman tipi seçilemez.'];
    }
    return [];
}
// ── G5/G6 — UYGUNLUK SATIRININ DÖRT DURUMU ─────────────────────────────────
/**
 * Panelin (G6) ve *"eksik"* damgasının (G5) **TEK yüklemi.** Dört durum:
 * `gecerli` · `yaklasiyor` (vade eşiği) · `doldu` · **`yok`** (hiç kayıt).
 *
 * ⚠️ **`yok` BİR VADE DURUMU DEĞİLDİR**, bu yüzden `yetkinlikVadeDurumu`
 * (ekran rozetinin ve eğitim modülünün tek kaynağı) **genişletilmedi**;
 * burada onun ÜSTÜNE bir kabuk geçirildi. Süresiz belge (`suresiz`)
 * **geçerlidir** — dolma uyarısı üretmez (§25/4 süre şerhi: kütüphane süre
 * dayatmaz, müşteri girer; **BOŞSA yetkinlik süresiz sayılır**).
 */
exports.UYGUNLUK_DURUMLARI = [
    'gecerli',
    'yaklasiyor',
    'doldu',
    'yok',
    /** ✏️ K9 (tur 5): başlangıcı gelecekte olan belge — bugün taşınmaz, eksiktir. */
    'henuz_degil',
    /** ✏️ K8 (tur 5): `on_kosul` kalemi (temel İSG) güncel istihdamdan ÖNCE alınmış —
     *  yeni istihdamda yenilenmeli. PTW'nin `yetkinlik_istihdam_oncesi` kuralının
     *  panel karşılığı; ikisi AYNI yüklemden okur (`onKosulIstihdamSonrasiMi`). */
    'istihdam_oncesi',
];
exports.uygunlukDurumuSchema = zod_1.z.enum(exports.UYGUNLUK_DURUMLARI);
/**
 * K18 (tur 5) — *"EKSİK"* İKİ ANLAMDA KONUŞUYORDU: günlük tarama
 * (`eksik_temel_isg`) **varlık** sorar (hiç kayıt yok), panel **dolmuş
 * belgeyi de** eksik sayar. Etiket ayrımı buradadır ve **tek sözlüktür**:
 * tarama da panel de aynı kelimeyi okur — *"Kayıt yok"* yalnız hiç kayıt
 * olmayan hâlin adıdır; *"eksik"* üst başlıktır (damga).
 */
exports.UYGUNLUK_DURUM_ETIKETI = {
    gecerli: 'Geçerli',
    yaklasiyor: 'Yakında dolacak',
    doldu: 'Süresi doldu',
    yok: 'Kayıt yok',
    henuz_degil: 'Henüz geçerli değil',
    istihdam_oncesi: 'Yeni istihdamda yenilenmeli',
};
/** Günlük taramanın (varlık) ve panelin *"hiç kayıt yok"* satırının ortak kelimesi. */
exports.EKSIK_KAYIT_YOK_ETIKETI = exports.UYGUNLUK_DURUM_ETIKETI.yok;
/**
 * Bir şart satırının durumu. `kayitlar` o şarta karşılık gelen TÜM kayıtlardır;
 * **hiç kayıt yoksa `yok`.** Birden çok kayıt varsa **en iyisi kazanır** — kişi
 * belgesini yenilediğinde eski satır onu *"dolmuş"* göstermemelidir.
 *
 * ⚠️ **HESAP `yetkinlikVadeDurumu`DAN OKUNUR** (K9 — üç okuyucunun tek
 * yüklemi); burada yalnız İKİ kabuk vardır: `suresiz` geçerlidir (§25/4 süre
 * şerhi) ve `on_kosul` kalemi istihdam başlangıcına bakar (K8).
 */
function uygunlukSatirDurumu(kayitlar, bugun, uyariEsigiGun, 
/** `on_kosul` kalemi için güncel istihdamın başlangıcı; diğer kalemlerde null. */
onKosulIstihdamBaslangic = null) {
    if (kayitlar.length === 0)
        return 'yok';
    const sira = [
        'gecerli',
        'yaklasiyor',
        'henuz_degil',
        'istihdam_oncesi',
        'doldu',
    ];
    let enIyi = 'doldu';
    for (const kayit of kayitlar) {
        const vade = (0, egitim_1.yetkinlikVadeDurumu)(kayit.baslangic, kayit.bitis, bugun, uyariEsigiGun);
        let durum = vade === 'suresiz' ? 'gecerli' : vade;
        // K8: bugün geçerli olsa bile güncel istihdamdan ÖNCE alınmışsa bu
        // istihdam için SAYILMAZ (temel İSG işe girişte tekrar ister — §2.11).
        if (onKosulIstihdamBaslangic !== null &&
            (durum === 'gecerli' || durum === 'yaklasiyor') &&
            !(0, egitim_1.onKosulIstihdamSonrasiMi)(kayit.baslangic, onKosulIstihdamBaslangic)) {
            durum = 'istihdam_oncesi';
        }
        if (sira.indexOf(durum) < sira.indexOf(enIyi))
            enIyi = durum;
    }
    return enIyi;
}
/**
 * G5 — *"eksik"* damgası. **POZİTİF LİSTE** (tur 5 / 0b dersi: `!== 'x'`
 * biçimindeki negatif koşul yeni token'da sessizce yanlışa döner):
 * `yaklasiyor` EKSİK DEĞİLDİR — bugün geçerli belge bir uyarıdır.
 */
exports.EKSIK_SAYILAN_DURUMLAR = [
    'doldu',
    'yok',
    'henuz_degil',
    'istihdam_oncesi',
];
function gorevlendirmeEksikMi(durumlar) {
    return durumlar.some((d) => exports.EKSIK_SAYILAN_DURUMLAR.includes(d));
}
// ── API sözleşmesi ──────────────────────────────────────────────────────────
/** Panelin ve kişi kartının okuduğu tek şart satırı. */
exports.uygunlukSatiriSchema = zod_1.z.object({
    /** Şartın kaynağı — `lookup_item.id` (yetkinlik/eğitim) veya `saglik`. */
    anahtar: zod_1.z.string(),
    ad: zod_1.z.string(),
    durum: exports.uygunlukDurumuSchema,
    /** En iyi kaydın bitişi; `null` = süresiz ya da kayıt yok (durum söyler). */
    gecerlilikBitis: zod_1.z.iso.date().nullable(),
    /**
     * ⚠️ **NEDEN SORULDUĞU GÖRÜNÜR:** boşsa *"herkese sorulan"* şarttır (temel
     * İSG · periyodik muayene), doluysa şartı doğuran görevlendirmelerin
     * adlarıdır. Panel *"neyim eksik"*i ancak *"neden isteniyor"*la birlikte
     * cevaplayabilir.
     */
    kaynakGorevlendirmeler: zod_1.z.array(zod_1.z.string()),
});
exports.gorevlendirmeSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    employmentId: zod_1.z.uuid(),
    gorevlendirmeTuruId: zod_1.z.uuid(),
    gorevlendirmeTuruAd: zod_1.z.string(),
    ekipmanTipiId: zod_1.z.uuid().nullable(),
    ekipmanTipiAd: zod_1.z.string().nullable(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    baslangicTarihi: zod_1.z.iso.date(),
    kaldirmaTarihi: zod_1.z.iso.date().nullable(),
    /** ⚠️ TÜRETİLİR — kolon değil (§25/5). */
    eksik: zod_1.z.boolean(),
    /** Damganın gerekçesi: eksik olan şartlar. Boşsa damga yoktur. */
    eksikSartlar: zod_1.z.array(exports.uygunlukSatiriSchema),
    /** 5½ / B1 — yalnız çalışan temsilcisi türünde dolu (§25/13). */
    temsilciMi: zod_1.z.boolean(),
    basTemsilci: zod_1.z.boolean(),
    belirlenmeYolu: exports.belirlenmeYoluSchema.nullable(),
    /** İSG kurulu (§28/C2) — yalnız "Kurul üyesi" türünde dolu. */
    kurulUyesiMi: zod_1.z.boolean(),
    kurulUyeTipi: kurul_1.kurulUyeTipiSchema.nullable(),
});
exports.kisiUygunlukPaneliSchema = zod_1.z.object({
    /**
     * ⚠️ **BÖLÜMLÜ KURULDU Kİ KKD ZİMMETİ GELİNCE YENİDEN YAZILMASIN**
     * (§25/6 · ERD §12/44). **Veri kaynağı olmayan bölüm GÖSTERİLMEZ** — boş
     * bir başlık, §2.40'ın *yalan söyleyen kontrol* sınıfına girer.
     */
    egitimler: zod_1.z.array(exports.uygunlukSatiriSchema),
    /**
     * ✏️ S1 (tur 5): sağlık bölümü **`SAGLIK_OKUMA_SAPKALARI` ile hizalıdır**
     * (✏️ YP-5, 30.09.2026: **veya kişinin KENDİ kartı** — tek yüklem
     * `uygunlukPaneliSaglikBolumuGorunurMu`) —
     * okuyamayan şapkada (izleyici) `null` iner ve ekran bölümü ÇİZMEZ (*veri
     * kaynağı olmayan bölüm gösterilmez*). Boş dizi *"şart yok"* derdi; null
     * *"sana gösterilmez"* der — ikisi ayrı cümledir.
     */
    saglik: zod_1.z.array(exports.uygunlukSatiriSchema).nullable(),
    gorevlendirmeler: zod_1.z.array(exports.uygunlukSatiriSchema),
    /**
     * ✏️ **MADDE 301 (ürün sahibi 01.10.2026 — Kapsam §16.11/10 ✏️): KİŞİ KENDİ
     * KARTINDA KENDİ KANAATİNİN KARARINI VE KISITLARINI GÖRÜR.** Yalnız kimlik
     * kolunda (`uygunlukPaneliErisimi` → `kendi`) dolar; **başkasının kartında
     * ALAN YOKTUR** — boş değil, YOK (Y5: kısıtlama API kenarında, ekran
     * gizlemesiyle değil). `null` = kendi kartı, kanaat kaydı yok.
     * ⚠️ İçerik: karar (sözlük adı + sınıfı) + kısıt cümleleri (`uygun_degil`
     * satırlarının `kisitIfadesi`). **Tanı · bulgu · tetkik değeri · hekim notu
     * · hekim bilgisi YOKTUR** (ilk üçü zaten tutulmuyor — §16.11/S1).
     */
    kendiKanaat: zod_1.z
        .object({
        kararAd: zod_1.z.string(),
        kararSinifi: saglik_1.uygunlukKararSinifiSchema.nullable(),
        kisitlar: zod_1.z.array(zod_1.z.string()),
    })
        .nullable()
        .optional(),
});
exports.gorevlendirmeOlusturSchema = zod_1.z.object({
    employmentId: zod_1.z.uuid(),
    gorevlendirmeTuruId: zod_1.z.uuid(),
    ekipmanTipiId: zod_1.z.uuid().nullable().optional(),
    baslangicTarihi: zod_1.z.iso.date(),
    /** 5½ / B1 — yalnız temsilci türünde; başka türde dolu gelirse 422 (serviste). */
    basTemsilci: zod_1.z.boolean().optional(),
    belirlenmeYolu: exports.belirlenmeYoluSchema.nullable().optional(),
    /** İSG kurulu (§28/C2) — "Kurul üyesi" türünde ZORUNLU, başka türde 422 (serviste). */
    kurulUyeTipi: kurul_1.kurulUyeTipiSchema.nullable().optional(),
});
/** ⚠️ KALDIRMA SİLME DEĞİLDİR — tarih yazılır, satır yaşamaya devam eder. */
exports.gorevlendirmeKaldirSchema = zod_1.z.object({
    kaldirmaTarihi: zod_1.z.iso.date(),
});
// ── B3 — TÜR BAZLI LİSTE ────────────────────────────────────────────────────
/**
 * *"Bu işyerinde ilkyardımcılar kimler"* satırı. **Yalnız YÜRÜRLÜKTEKİ
 * kayıtlar** — kaldırılanlar kişi kartında yaşar, bu listede görünmez
 * (§25/1: *"bugün kim ekipte"* ≠ *"olay tarihinde kim vardı"*).
 */
exports.gorevlendirmeListeSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    personAdSoyad: zod_1.z.string(),
    gorevlendirmeTuruId: zod_1.z.uuid(),
    gorevlendirmeTuruAd: zod_1.z.string(),
    ekipmanTipiAd: zod_1.z.string().nullable(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    baslangicTarihi: zod_1.z.iso.date(),
    eksik: zod_1.z.boolean(),
    eksikSartlar: zod_1.z.array(exports.uygunlukSatiriSchema),
    basTemsilci: zod_1.z.boolean(),
    belirlenmeYolu: exports.belirlenmeYoluSchema.nullable(),
    kurulUyeTipi: kurul_1.kurulUyeTipiSchema.nullable(),
});
// ── 5½ / B3 — İŞYERİ DÜZEYİ TÜRETME ─────────────────────────────────────────
/**
 * *"Bu işyeri bu görevlendirmeden kaç kişi taşımalı, kaç kişi taşıyor?"* —
 * TÜRETİLİR.
 *
 * ✏️ **TUR 8 / A2 — ÜÇ SAYI, İKİ DEĞİL.** *"Kaç kişi taşıyor"* sorusunun
 * **iki** cevabı vardır ve ikisi de gerçektir: kaç kişiye görevlendirme
 * VERİLMİŞ (`mevcut`) ve o kişilerden kaçı görevin **şartlarını taşıyor**
 * (`yeterli` — görevlendirmenin *"eksik"* damgası yanmayanlar).
 * ⚠️ **YETERLİLİK ŞART MATRİSİNDEN SORULUR, İKİNCİ KEZ HESAPLANMAZ:** damga
 * `topluSartCozucuKur` → `uygunlukSatirDurumu` yükleminden gelir — listenin
 * satırındaki damgayla **aynı** yüklem (kopya çıkarsa biri ötekini yalanlar,
 * §2.40'ın *tek yüklem* kuralı).
 * ⚠️ **`eksik` GÖREVLENDİRİLMİŞ'E DEĞİL YETERLİ'YE BAKAR** (A3): sertifikası
 * olmayan ilkyardımcı **denetimde ilkyardımcı sayılmaz**; sayının tutması
 * yükümlülüğü karşılamaz.
 */
exports.isyeriZorunluGorevlendirmeSatiriSchema = zod_1.z.object({
    gorevlendirmeTuruId: zod_1.z.uuid(),
    gorevlendirmeTuruAd: zod_1.z.string(),
    bicim: zod_1.z.enum(['basamak', 'oran']),
    gereken: zod_1.z.number().int().min(0),
    /** Yürürlükte görevlendirme VERİLMİŞ kişi sayısı. */
    mevcut: zod_1.z.number().int().min(0),
    /** Bunlardan şartları TAM olanlar (*"eksik"* damgası yanmayanlar). */
    yeterli: zod_1.z.number().int().min(0),
    /** `gereken - yeterli` — sayı tutup damga yanıyorsa da eksik VARDIR. */
    eksik: zod_1.z.number().int().min(0),
});
exports.isyeriZorunluGorevlendirmelerSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    calisanSayisi: zod_1.z.number().int().min(0),
    /** Kuralı sayı üretmeyen türler (bölen boş) listeye GİRMEZ — sistem susar. */
    satirlar: zod_1.z.array(exports.isyeriZorunluGorevlendirmeSatiriSchema),
    toplamEksik: zod_1.z.number().int().min(0),
});
exports.gorevlendirmeListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.gorevlendirmeListeSatiriSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
//# sourceMappingURL=gorevlendirme.js.map